"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchParamAccessor = exports.useSearchParamState = exports.objectFromSearchParams = exports.objectToSearchParams = void 0;
const base64_js_1 = require("base64-js");
const hooks_1 = require("common/hooks");
const hooks_2 = require("common/hooks");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const toBase64Url = (str) => {
    const byteArray = new TextEncoder().encode(str);
    return (0, base64_js_1.fromByteArray)(byteArray)
        .replace(/=+$/, "")
        .replaceAll("+", "-")
        .replaceAll("/", "-");
};
const fromBase64Url = (base64url) => {
    const byteArray = (0, base64_js_1.toByteArray)(base64url
        .replaceAll("-", "+")
        .replaceAll("-", "/")
        .padEnd(Math.ceil(base64url.length / 4) * 4, "="));
    return new TextDecoder().decode(byteArray);
};
const objectToSearchParams = (obj) => {
    const rest = {};
    const searchParams = new URLSearchParams();
    const traverse = (obj, paths = []) => {
        for (const [key, value] of Object.entries(obj)) {
            const currentPaths = [...paths, key];
            if (!key.includes(".") &&
                value &&
                typeof value === "object" &&
                !Array.isArray(value)) {
                traverse(value, currentPaths);
            }
            else if (!key.includes(".") && typeof value === "string") {
                searchParams.set(currentPaths.join("."), value);
            }
            else {
                setByPath(rest, currentPaths, value);
            }
        }
    };
    traverse(obj);
    if (Object.keys(rest).length) {
        searchParams.set("o", toBase64Url(JSON.stringify(rest)));
    }
    return searchParams;
};
exports.objectToSearchParams = objectToSearchParams;
const objectFromSearchParams = (searchParams) => {
    const rest = searchParams.get("o");
    searchParams.delete("o");
    const base = rest ? JSON.parse(fromBase64Url(rest)) : {};
    for (const [key, value] of searchParams.entries()) {
        setByPath(base, key.split("."), value);
    }
    return base;
};
exports.objectFromSearchParams = objectFromSearchParams;
const setByPath = (obj, paths, value, pathIndex = 0) => {
    if (pathIndex >= paths.length - 1) {
        obj[paths[pathIndex]] = value;
    }
    else {
        let target = obj[paths[pathIndex]];
        if (!target || typeof target !== "object") {
            target = {};
            obj[paths[pathIndex]] = target;
        }
        setByPath(target, paths, value, pathIndex + 1);
    }
};
const useSearchParamState = () => {
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const params = (0, hooks_2.useNormalizedMemo)(() => {
        return (0, exports.objectFromSearchParams)(searchParams);
    }, [searchParams]);
    const setParams = (0, react_1.useCallback)((params) => {
        const searchParams = (0, exports.objectToSearchParams)(params);
        setSearchParams(searchParams);
    }, [setSearchParams]);
    return [params, setParams];
};
exports.useSearchParamState = useSearchParamState;
const useSearchParamAccessor = () => {
    return (0, hooks_1.useAccessorFromArray)((0, exports.useSearchParamState)());
};
exports.useSearchParamAccessor = useSearchParamAccessor;
const normalizeDifference = (newObject, oldObject) => {
    if (newObject && oldObject && typeof newObject === "object") {
        if (!Array.isArray(newObject)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const response = {};
            let changed = false;
            for (const [key, value] of Object.entries(newObject)) {
                const [field, _changed] = normalizeDifference(value, 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                oldObject[key]);
                response[key] = field;
                changed = changed || _changed;
            }
            for (const key of Object.keys(oldObject)) {
                if (!(key in newObject)) {
                    changed = true;
                }
            }
            return [changed ? response : oldObject, changed];
        }
        else {
            let changed = !Array.isArray(oldObject) || newObject.length !== oldObject.length;
            const response = newObject.map((item, index) => {
                const [field, _changed] = normalizeDifference(item, 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                oldObject[index]);
                changed = changed || _changed;
                return field;
            });
            return [(changed ? response : oldObject), changed];
        }
    }
    return [newObject, newObject !== oldObject];
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _window = window;
_window.objectToSearchParams = exports.objectToSearchParams;
_window.objectFromSearchParams = exports.objectFromSearchParams;
_window.normalizeDifference = normalizeDifference;
_window.getCurrentParams = () => {
    console.log((0, exports.objectFromSearchParams)(new URLSearchParams(location.search)));
};
